import { SVGProps } from 'react';

export default function AirHandlerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={1.5}
      stroke='currentColor'
      aria-hidden='true'
      {...props}
    >
      <rect x='5.25' y='3' width='13.5' height='18' rx='1.5' />
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M8.25 6.75h7.5M8.25 9h7.5M5.25 11.25h13.5'
      />
      <circle cx='12' cy='15.75' r='3' />
      <circle cx='12' cy='15.75' r='0.75' />
    </svg>
  );
}
